import { useEffect } from 'react';

// Тема оформления кабинета: светлая, тёмная или как в системе. Выбор хранится в браузере.
// Применяется только внутри кабинета (AppShell); публичные страницы остаются светлыми.

const KEY = 'svod_theme';
export const THEME_OPTIONS = [
    { value: 'light', label: 'Светлая' },
    { value: 'dark', label: 'Тёмная' },
    { value: 'system', label: 'Авто', title: 'Как в настройках устройства' },
];

export function getThemePreference() {
    try {
        const value = window.localStorage.getItem(KEY);
        return THEME_OPTIONS.some((o) => o.value === value) ? value : 'light';
    } catch {
        return 'light';
    }
}

export function saveThemePreference(value) {
    try { window.localStorage.setItem(KEY, value); } catch { /* приватный режим — тема до перезагрузки */ }
}

function systemPrefersDark() {
    return Boolean(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
}

export function resolveTheme(preference) {
    if (preference === 'system') return systemPrefersDark() ? 'dark' : 'light';
    return preference === 'dark' ? 'dark' : 'light';
}

export function applyTheme(preference) {
    const theme = resolveTheme(preference);
    if (theme === 'dark') document.documentElement.setAttribute('data-theme', 'dark');
    else document.documentElement.removeAttribute('data-theme');
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', theme === 'dark' ? '#141519' : '#6a4cd6');
}

export function clearTheme() {
    document.documentElement.removeAttribute('data-theme');
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', '#6a4cd6');
}

/**
 * Оформление, которое организатор выбрал для опроса или сессии вопросов: на страницах для участников.
 * Действует, пока страница открыта; кабинет при возврате применит свою тему сам.
 */
export function useParticipantTheme(theme) {
    useEffect(() => {
        if (theme !== 'dark') return undefined;
        applyTheme('dark');
        return () => clearTheme();
    }, [theme]);
}
